export const soundTimeline = [
    {
        name: 'inStart',
        startTime: 0,
        volume: 0.5,
    },
    {
        name: 'twinkle_reverb',
        startTime: 2800,
        volume: 0.5,
    },
    {
        name: 'reveal',
        startTime: 2800,
        volume: 0.5,
    },
    {
        name: 'twinkle',
        startTime: 4500,
        volume: 0.5,
    },
    {
        name: 'OutStart',
        startTime: 14000,
        volume: 0.3,
    },
];
